// `window.moment` / `window.momentTimezone` used to be published by the frontend pack. They have
// no reader in the application code any more (`app.js` and `helpers.js` import moment directly
// now, instead of leaning on the global), but the Playwright suite reads `window.moment` to build
// the publish-date fixtures, so the globals stay — and stay in their own module, so they are
// assigned before any importer of this file runs rather than after (entry-body statements run
// last in an ES module graph).
//
// Both names point at the same object: moment-timezone mutates the moment instance it wraps and
// re-exports it, which is exactly what the two `require`s resolved to before.
import moment from 'moment-timezone'

window.moment = moment
window.momentTimezone = moment

export default moment
